import Button from '../Button'
import IconButton from '../IconButton'
import './styles.scss'

const TableCell = ({
    className = '',
    titleClass = '',
    textClass = '',
    btnClass = '',
    iconBtnClass = '',
    title,
    text,
    hasBtn,
    hasIconBtn,
    icon,
    allowCopy,
    textAreaRef,
    isTooltipVisible,
    tooltipText,
    onIconClick,
    children,
}) => (
    <div className={`table__cell ${className}`}>
        {title && <div className={`table__cell__title ${titleClass}`}>{title}</div>}
        {text != null && <span className={`table__cell__text ${textClass}`}>{text}</span>}
        {allowCopy && <textarea aria-hidden="true" readOnly defaultValue={text} ref={textAreaRef} />}
        {hasBtn && <Button className={btnClass} />}
        {hasIconBtn && (
            <IconButton
                onClick={onIconClick}
                isTooltipVisible={isTooltipVisible}
                tooltipText={tooltipText}
                icon={icon}
                className={iconBtnClass}
            />
        )}
        {children}
    </div>
)

TableCell.propTypes = {
    className: PropTypes.string,
    titleClass: PropTypes.string,
    textClass: PropTypes.string,
    btnClass: PropTypes.string,
    iconBtnClass: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    hasBtn: PropTypes.bool,
    hasIconBtn: PropTypes.bool,
    icon: PropTypes.string,
    allowCopy: PropTypes.bool,
    textAreaRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    isTooltipVisible: PropTypes.bool,
    tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClick: PropTypes.func,
}

export default TableCell
